// extracted by mini-css-extract-plugin
export default {"icon":"iZde4j","title":"ijg6ke","buttons":"rIDgjP","actionButton":"a5zEek"};